type StartTitleAnimationOptions = {
  originalTitle?: string;
  frameDuration?: number;
};

const phases = {
  DISPLAY: 0,
  MORPH_TO_BINARY: 1,
  BINARY_FLUX: 2,
  MORPH_TO_TEXT: 3,
} as const;

type PhaseKey = (typeof phases)[keyof typeof phases];

const phaseDurations: Record<PhaseKey, number> = {
  [phases.DISPLAY]: 20,
  [phases.MORPH_TO_BINARY]: 10,
  [phases.BINARY_FLUX]: 10,
  [phases.MORPH_TO_TEXT]: 10,
};

const getRandomBinary = () => (Math.random() > 0.5 ? "1" : "0");

const buildRandomOrder = (length: number) => {
  const indices = Array.from({ length }, (_, index) => index);
  for (let index = indices.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [indices[index], indices[swapIndex]] = [indices[swapIndex], indices[index]];
  }
  return indices;
};

export const startAnimatedDocumentTitle = ({
  originalTitle = "IKaniewski",
  frameDuration = 150,
}: StartTitleAnimationOptions = {}) => {
  let currentPhase: PhaseKey = phases.DISPLAY;
  let phaseFrame = 0;
  let morphOrder = buildRandomOrder(originalTitle.length);

  const morphTitle = () => {
    let result = originalTitle.split("");

    switch (currentPhase) {
      case phases.DISPLAY:
        result = originalTitle.split("");
        break;

      case phases.MORPH_TO_BINARY: {
        const morphProgress =
          phaseFrame / phaseDurations[phases.MORPH_TO_BINARY];
        const charsToReplace = Math.floor(originalTitle.length * morphProgress);
        for (let index = 0; index < charsToReplace; index += 1) {
          const targetIndex = morphOrder[index];
          result[targetIndex] = getRandomBinary();
        }
        break;
      }

      case phases.BINARY_FLUX:
        result = Array.from({ length: originalTitle.length }, getRandomBinary);
        break;

      case phases.MORPH_TO_TEXT: {
        const restoreProgress =
          phaseFrame / phaseDurations[phases.MORPH_TO_TEXT];
        const charsToRestore = Math.floor(
          originalTitle.length * restoreProgress,
        );
        result = Array.from({ length: originalTitle.length }, getRandomBinary);
        for (let index = 0; index < charsToRestore; index += 1) {
          result[index] = originalTitle[index];
        }
        break;
      }
    }

    document.title = result.join("");
    phaseFrame += 1;

    if (phaseFrame >= phaseDurations[currentPhase]) {
      phaseFrame = 0;
      currentPhase = ((currentPhase + 1) %
        Object.keys(phases).length) as PhaseKey;
      if (currentPhase === phases.MORPH_TO_BINARY) {
        morphOrder = buildRandomOrder(originalTitle.length);
      }
    }
  };

  const intervalId = window.setInterval(morphTitle, frameDuration);

  return () => {
    window.clearInterval(intervalId);
    document.title = originalTitle;
  };
};
